<script setup lang="ts">
  import { Toaster as Sonner, type ToasterProps } from 'vue-sonner'
  import Icon from '../icon/Icon.vue'

  const props = withDefaults(defineProps<ToasterProps>(), {
    position: 'top-center',
  })
</script>

<template>
  <Sonner
    class="toaster group"
    v-bind="props"
    :visible-toasts="1"
    :expand="false"
    :style="{
      '--width': '626px',
    }"
    :toast-options="{
      class:
        'toast-font max-w-full w-fit min-h-14 left-0 right-0 mx-auto bg-white text-m-medium shadow-lg text-state-normal flex items-center gap-2 rounded-3xl p-4 [&_svg]:size-6',
      unstyled: true,
      classes: {
        error: 'text-state-failure',
        success: 'text-state-success',
        warning: 'text-state-warning',
        info: 'text-state-normal',
      },
    }"
  >
    <template #success-icon>
      <Icon icon="Switch-Fill-Check" />
    </template>

    <template #error-icon>
      <Icon icon="Function-Fill-Close" />
    </template>

    <template #warning-icon>
      <Icon icon="Function-FiII-Warning" />
    </template>

    <template #info-icon>
      <Icon icon="Function-FiII-Caution" />
    </template>
  </Sonner>
</template>
